export default "__VITE_ASSET__DOwMG_wk__"